import { defineMessages } from 'react-intl';

export default defineMessages({
  firstPage: {
    id: 'pagination.firstPage',
    defaultMessage: 'First Page',
  },
  previousPage: {
    id: 'pagination.previousPage',
    defaultMessage: 'Previous Page',
  },
  currentPage: {
    id: 'pagination.currentPage',
    defaultMessage: 'Current Page',
  },
  nextPage: {
    id: 'pagination.nextPage',
    defaultMessage: 'Next Page',
  },
  lastPage: {
    id: 'pagination.lastPage',
    defaultMessage: 'Last Page',
  },
  perPage: {
    id: 'pagination.perPage',
    defaultMessage: 'per page',
  },
  of: {
    id: 'pagination.of',
    defaultMessage: 'of',
  },
});
